// extracted by mini-css-extract-plugin
export default {"figmaToZeplin":"gLkywXqsOONsDebgLi5o","bouncingShapes":"CO9MdzacSp3PQKTAAgI6","bounce-4":"ZyPtKMuuegatzTdKehss"};